<template>
    <div class="create-vehicle-form">
        <h3>
            Fahrzeugdaten
        </h3>

        <div class="row mt-3">
            <div class="col-md-6">
                <csp-form-group-input :form="vehicleForm" property="model" required/>
            </div>

            <div class="col-md-6">
                <csp-form-group-input :form="vehicleForm" property="licensePlate" required/>
            </div>

            <div class="col-md-6">
                <csp-form-group-datepicker v-if="isComprehensiveClaimTypeSelected" :form="vehicleForm"
                    property="registrationDate" required/>
            </div>

            <div class="col-md-6">
                <csp-form-group-input v-if="isComprehensiveClaimTypeSelected" :form="vehicleForm"
                    property="mileage" required type="number"/>
            </div>
        </div>

        <csp-record-create-image-file-upload
            accepted-mime-types="image/jpeg, image/png, application/pdf"
            transform-mime-types="image/jpeg, image/png"
            :upload-file-category-id="uploadFileCategory"
            upload-label="KFZ Schein"
            :upload-session-id="uploadSessionId"/>
    </div>
</template>

<script>
    import Form from '@form/Form';
    import Container from '@services/Container';
    import FileCategoryEnum from '@js/enums/file/FileCategoryEnum';

    export default {
        props: {
            vehicleForm: {
                type: Form,
                required: true,
            },
            isComprehensiveClaimTypeSelected: {
                type: Boolean,
                required: true,
            },
            uploadSessionId: {
                type: String,
                required: true,
            },
        },
        computed: {
            uploadFileCategory() {
                return FileCategoryEnum.REGISTRATION_DOCUMENT;
            },
        },
        created() {
            this.loginStatus = Container.getInstance().getLoginStatusStore();
        },
    }
</script>
